uvex-wp-blog-teaser {
  display: grid;
  column-gap: 1rem;
  row-gap: 1rem;
  grid-template-columns: 1fr;
  min-height: 320px;

  @media (min-width: 544px) {
    grid-template-columns: repeat(3, minmax(0, 1fr));
  }

  @media (min-width: 768px) {
    column-gap: 2rem;
  }

  .wp-blog-teaser {
    position: relative;
    border-bottom-right-radius: 25px;
    padding-bottom: 2rem;
    box-shadow: 0px 0px 20px #efefef;
    border: 1px solid #efefef;
  }

  .wp-blog-teaser-date {
    padding: 0.5rem 1rem 0 1rem;
    max-width: 100%;
    font-weight: 100;
    color: #dedede;
    font-size: 2rem;
    line-height: 1.2;
    text-align: right;
  }

  .wp-blog-teaser-image {
    background: #fff;
  }

  img {
    object-fit: cover;
    border-bottom-right-radius: 25px;
  }

  h3 {
    font-weight: 400;
    line-height: 1.8;
    font-size: 1.2rem;
    padding: 0 1rem;
  }

  .btn {
    margin: 0 1rem;
  }
}
